export default __webpack_public_path__ + "static/media/Battleblessed Opus.98fba7f8.jpg";